import sendEvent from "./sendEvent";

export { sendEvent };
